import { Text } from 'ui';
import { SUPPORT_EMAIL } from '../../../constants';

export enum FileUploadType {
  SingleFile = 'single file upload',
  MultipleFile = 'multiple files upload',
}

interface IProps {
  files: File[];
  id: FileUploadType;
}

export const DuplicateFileVersionModal = ({ files, id }: IProps) => {
  const fileName = (() => {
    if (!files) return '';
    return files.map((f) => f.name).join(', ');
  })();

  const textStyles = 'text-left text-base font-normal text-white';

  return (
    <div>
      <div>
        <p className={textStyles}>
          {`You've already uploaded ${files.length === 1 ? 'a file' : 'files'} named ${fileName}.  
  ${
    id === FileUploadType.SingleFile
      ? 'Please rename the file or upload a different one.'
      : 'Files with duplicate names will be removed, but unique ones will still be uploaded.'
  }`}
        </p>

        <br />
        <p className={textStyles}>
          Still can&apos;t find what you&apos;re looking for? Reach out to us directly via email at{' '}
          <a className="font-bold text-link underline" href={`mailto:${SUPPORT_EMAIL}`}>
            support@authentise.com
          </a>
          , and our dedicated team will get back to you as soon as possible.
        </p>
      </div>
    </div>
  );
};
